/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/transaksi-manual?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  detail({}, id) {
    const url = `/transaksi-manual/${id}`;
    return http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/transaksi-manual`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/transaksi-manual/${payload.id}`;
    return http.put(url, payload.params);
  },

  upload({}, payload) {
    const url = `/transaksi-manual/upload`;
    return http.post(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  downloadTemplate({}, payload) {
    const url = process.env.VUE_APP_API_URL + `/transaksi-manual/template-upload?${queryString(payload)}`;
    return url;
  },

  jenisPembayaran() {
    const url = `/transaksi-manual/jenis-pembayaran`;
    return http.get(url).then(({ data }) => data);
  },

  logAktivitas({}, payload) {
    const url = `/transaksi-manual/log?${queryString(payload.params)}`;
    return http.get(url).then(({ data }) => data);
  },

  delete({}, id) {
    const url = `/transaksi-manual/${id}`;
    return http.delete(url);
  },
};
